var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"border":"","loading":_vm.loading,"columns":_vm.columns,"data":_vm.data}}),_vm._v(" "),_c('div',{staticStyle:{"margin":"20px 0"}},[_c('Page',{staticStyle:{"float":"right"},attrs:{"total":_vm.total},on:{"on-change":_vm.pageChange}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5932a075","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/process/performanceManagement/components/MyAchievementsComponents/ApprovalHistory.vue
// module id = null
// module chunks = 